import React from "react";

function KeyFeaturesWardrobe(props) {
  
  return(
        <div className={"KeyFeaturesWardrobe textModule1 Orangeh6 " + props.CustomClass}>
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-xl-6 col-md-7 col-lg-7 mb-5 mb-md-0">
                        <div className="textModule1Gray"
                        dangerouslySetInnerHTML={{
                        __html: props.contentLeft
                        }}></div>
                    </div>
                    <div className="col-xl-4 col-md-5 col-lg-4 text-left">
                        <div className="bigUl"
                        dangerouslySetInnerHTML={{
                        __html: props.contentRight
                        }}></div>
                    </div>
                </div>
            </div>
        </div>
  );
}
export default KeyFeaturesWardrobe;